import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { Passes } from "@components/CompetitionSeasonStats/Passes/Passes"
import { PlayerFouls } from "@components/CompetitionSeasonStats/PlayerFouls/PlayerFouls"
import { PlayerDuels } from "@components/CompetitionSeasonStats/PlayerDuels/PlayerDuels"
import { PlayerShots } from "@components/CompetitionSeasonStats/PlayerShots/PlayerShots"
import { PlayerMinutes } from "@components/CompetitionSeasonStats/PlayerMinutes/PlayerMinutes"
import { PlayerBalls } from "@components/CompetitionSeasonStats/PlayerBalls/PlayerBalls"

export function PlayerCompetitionSeasonStatsDefender({
  passes,
  shortPasses,
  longPasses,
  percentagePasses,
  fouls,
  concededFouls,
  redCards,
  yellowCards,
  duels,
  wonDuels,
  shots,
  shotsOnTarget,
  lostBalls,
  retrievedBalls,
  minutes,
  assists,
  contrasts,
  clearances,
  goals,
  blockShots,
  gamesPlayed,
}: {
  passes: number
  shortPasses: number
  longPasses: number
  percentagePasses: number
  fouls: number
  concededFouls: number
  redCards: number
  yellowCards: number
  duels: number
  wonDuels: number
  shots: number
  shotsOnTarget: number
  lostBalls: number
  retrievedBalls: number
  minutes: number
  assists: number
  contrasts: number
  clearances?: number
  goals: number
  blockShots?: number
  gamesPlayed: number
}) {
  return (
    <Col>
      <PlayerMinutes
        gamesPlayed={gamesPlayed}
        minutes={minutes}
        assists={assists}
        contrasts={contrasts}
        goals={goals}
      />
      <Row>
        <Col md={6} className={"centerColumn"}>
          <Passes
            passes={passes}
            shortPasses={shortPasses}
            longPasses={longPasses}
            percentagePasses={percentagePasses}
          />
        </Col>
        <Col md={6} className={"centerColumn"}>
          <PlayerFouls fouls={fouls} concededFouls={concededFouls} redCards={redCards} yellowCards={yellowCards} />
        </Col>
      </Row>
      <Row>
        <Col md={6} className={"centerColumn"}>
          <PlayerBalls lostBalls={lostBalls} retrievedBalls={retrievedBalls} />
          <PlayerShots shots={shots} shotsOnTarget={shotsOnTarget} />
        </Col>
        <Col md={6} className={"centerColumn"}>
          <PlayerDuels duels={duels} clearances={clearances} blockShots={blockShots} wonDuels={wonDuels} />
        </Col>
      </Row>
    </Col>
  )
}
